import { getBaseRole } from '@/helpers/customRoles';
export const filterForJornal = (role, type, stateFilter) =>{
    console.log(role)
 
    if((getBaseRole(role) !== 'children' && getBaseRole(role) !== 'parent') && type === "group"){
      const res = [
        {
          ...stateFilter[0],
          events: stateFilter[0].events.filter((el) => !(el.is_cancel == '1' && el.interval_type == 'one-time'))
        }
      ];
      return [
        {
          ...res[0],
          events: res[0].events.map((event)=>({
            ...event,
            reports: event.reports.filter((el)=> +el.status <= 5)
                                  .filter((el) => (event.start_date && event.interval_type=="regular") ? (+el.date_conference.replace(/[-\s]/g, '') >= +event.start_date.replace(/[-\s]/g, '')) : true)
          }))
        }
      ];
    }
    if((getBaseRole(role) == 'children' || getBaseRole(role) == 'parent') && type == "group"){
      const res = [
        ...stateFilter.map((el)=>{
          return {
            ...el,
            timetablePrivateEvents: el.timetablePrivateEvents.filter((filterElement)=>!(filterElement.is_cancel == '1' && filterElement.interval_type == 'one-time')).map((elem)=>{
              return {
                ...elem,
                reports: elem.reports.filter((el)=> +el.status <= 5)
                                     .filter((element) => (elem.start_date && elem.interval_type=="regular") ? (+element.date_conference.replace(/[-\s]/g, '') >= +elem.start_date.replace(/[-\s]/g, '')) : true)
              }
            })
          }
        })
      ];
      return res;
    }
   
    return stateFilter;
}

export const filterForReports = (stateFilter) =>{
  return stateFilter.filter((el) => (el.start_date && el.interval_type=="regular") ? (+el.date_conference.replace(/[-\s]/g, '') >= +el.start_date.replace(/[-\s]/g, '')) : true)
}
